<ng-container *ngIf="action$ | async"></ng-container>

<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-full table-fixed">
  <ng-container matColumnDef="selected">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <mat-checkbox
        *ngIf="isActiveMaterial(item.material, item.filmMaterial, item.buttMaterial)"
        (change)="$event ? masterToggle(item) : null"
        [checked]="selection.hasValue() && isAllSelected(item)"></mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="combined">
    <td mat-cell *matCellDef="let element" [attr.colspan]="13">
      <div class="flex flex-row">
        <div class="flex flex-col">
          <p>
            <span class="font-normal" i18n
              >Материал фасада
              <span class="text-bold"
                >{{ element.title }} <span>( {{ element.area | formatNumber : 3 : false }} м²)</span>({{
                  element.totalCounts
                }})</span
              ></span
            >
          </p>
          <div *ngIf="element?.filmMaterial?.name?.length > 0" i18n class="font-normal"
            >Материал пленки
            <span class="text-bold"
              >{{
                bazisMaterialHelper.formatMaterialNameAndArticle(
                  element.filmMaterial.name,
                  element.filmMaterial.article
                )
              }}
            </span></div
          >
          <div *ngIf="element?.buttMaterial?.name?.length > 0" i18n class="font-normal"
            >Материал облицовки
            <span class="text-bold"
              >{{
                bazisMaterialHelper.formatMaterialNameAndArticle(
                  element.buttMaterial.name,
                  element.buttMaterial.article
                )
              }}
            </span></div
          >
        </div>
        <div class="px-4 flex flex-row gap-2 items-start">
          <ng-container
            *ngIf="
              selectionMode && isActiveMaterial(element.material, element.filmMaterial, element.buttMaterial);
              else noSelectionModeTmpl
            ">
            <button
              i18n
              mat-raised-button
              class="hidden"
              color="accent"
              [disabled]="selection.selected.length === 0"
              (click)="replace()"
              >Заменить</button
            >
            <button i18n mat-stroked-button color="primary" (click)="stopReplacing()">Отмена</button>
          </ng-container>

          <ng-template #noSelectionModeTmpl>
            <button
              class="hidden"
              mat-icon-button
              i18n-matTooltip
              matTooltip="Заменить материал"
              (click)="startReplacing(replaceMaterial(element.material, element.filmMaterial, element.buttMaterial))">
              <mat-icon>swap_horizontal_circle</mat-icon>
            </button>
            <button
              class="hidden"
              mat-icon-button
              i18n-matTooltip
              matTooltip="Заменить облицовку"
              (click)="startReplacing(replaceEdge(element.material, element.filmMaterial, element.buttMaterial))">
              <mat-icon svgIcon="edge_swap"></mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="height">
    <th mat-header-cell *matHeaderCellDef>Высота</th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="width">
    <th mat-header-cell *matHeaderCellDef>Ширина</th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="count">
    <th mat-header-cell *matHeaderCellDef>Кол-во</th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="direction">
    <th mat-header-cell *matHeaderCellDef>Направление текстуры</th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="edge">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon matTooltip="Облицовка кромки">border_style</mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="fasteners">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="milling_cutter" matTooltip="Присадка"></mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="angles-processing">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="vector_rectangle" matTooltip="Обработка углов"></mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="slots">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="slot" matTooltip="Паз"></mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="handles">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon matTooltip="Ручка">web_asset</mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="milling">
    <th mat-header-cell *matHeaderCellDef>
      <mat-icon svgIcon="milling" matTooltip="Фрезеровка"></mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="remark">
    <th class="text-end" mat-header-cell i18n *matHeaderCellDef>Примечание</th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="hidden"></td>
  </ng-container>

  <!-- Расширенный контент -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="13">
      <div class="flex truncate">
        <table mat-table [dataSource]="element.facade" class="w-full table-fixed">
          <ng-container matColumnDef="selected">
            <td mat-cell *matCellDef="let item">
              <mat-checkbox
                *ngIf="isActiveMaterialRow(item)"
                (change)="selection.toggle(item)"
                [checked]="selection.isSelected(item)"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="height">
            <td mat-cell *matCellDef="let element">{{ element.width }}</td>
          </ng-container>

          <ng-container matColumnDef="width">
            <td mat-cell *matCellDef="let element">{{ element.height }}</td>
          </ng-container>

          <ng-container matColumnDef="count">
            <td mat-cell *matCellDef="let element" class="">{{ element.count }}</td>
          </ng-container>

          <ng-container matColumnDef="direction">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ getDirectionIcon(element.textureDirection) }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="edge">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasEdges(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="fasteners">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasFasteners(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="angles-processing">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasAngleProcessing(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="slots">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasSlots(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="handles">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasHandle(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="milling">
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{ hasMilling(element) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="remark">
            <td mat-cell *matCellDef="let element">
              <mat-form-field appearance="outline" class="w-full no-label no-subscript mini-input">
                <input matInput [matMenuTriggerFor]="remarkFull" readonly [value]="element.remark || ''" />
              </mat-form-field>

              <mat-menu #remarkFull="matMenu">
                <div class="w-full" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-full dense-input no-label no-subscript">
                    <textarea
                      [(ngModel)]="element.remark"
                      cols="50"
                      rows="7"
                      matInput
                      i18n-placeholder
                      placeholder="Введите примечание"></textarea>
                  </mat-form-field>
                </div>
              </mat-menu>
            </td>
          </ng-container>

          <ng-container matColumnDef="menu">
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item [disabled]="disabled" (click)="edit(element)">
                  <mat-icon>edit</mat-icon>
                  <span i18n>Редактировать</span>
                </button>
                <button mat-menu-item [disabled]="disabled" (click)="copy(element)">
                  <mat-icon svgIcon="content_copy"></mat-icon>
                  <span i18n>Создать на основе</span>
                </button>
                <button mat-menu-item [disabled]="disabled" (click)="delete(element)">
                  <mat-icon>delete</mat-icon>
                  <span i18n>Удалить</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns"></tr>
        </table>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsHeader"></tr>
  <tr mat-row *matRowDef="let element; columns: columns"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"></tr>
</table>
